<template>
  <div style="width:100%;overflow-y:auto;overflow-x:hidden;height:100%;">
    <div style="padding: 0;widows: 100%;">
      <div class="big-top">
        <span
          style="font-size: 14px;font-family: PingFangSC-Regular, PingFang SC;font-weight: 400;color: #2D2D2D;"
          >车系</span
        >
        <el-select
          size="mini"
          clearable
          style="width:180px;margin-left:16px"
          v-model="listQuery.seriesId"
        >
          <el-option
            v-for="item in seriesOptions"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          ></el-option>
        </el-select>
        <el-radio-group
          class="filter-item"
          size="mini"
          style="margin:0 16px"
          @change="dateTypeChange"
          v-model="listQuery.dateType"
        >
          <el-radio-button :label="1">按日</el-radio-button>
          <el-radio-button :label="3">按周</el-radio-button>
          <el-radio-button :label="2">按月</el-radio-button>
        </el-radio-group>
        <el-date-picker
          :picker-options="datePickerOption"
          class="filter-item"
          size="mini"
          v-if="listQuery.dateType == 1"
          :clearable="false"
          v-model="listQuery.searchDate"
          type="date"
          format="yyyy年MM月dd日"
          placeholder="选择日"
        >
        </el-date-picker>
        <div id="currentWeekly">
          <el-date-picker
            :picker-options="datePickerOption"
            class="filter-item"
            size="mini"
            v-if="listQuery.dateType == 3"
            :clearable="false"
            v-model="listQuery.searchDate"
            v-on:change="dateStart"
            type="week"
            format="yyyy年WW周"
            placeholder="选择周"
          >
          </el-date-picker>
        </div>
        <el-date-picker
          :picker-options="datePickerOption"
          class="filter-item"
          size="mini"
          v-if="listQuery.dateType == 2"
          :clearable="false"
          v-model="listQuery.searchDate"
          type="month"
          format="yyyy年MM月"
          placeholder="选择月"
        >
        </el-date-picker>
        <el-button
          class="filter-item"
          size="mini"
          type="info"
          icon="el-icon-search"
          @click="doSearch"
          style="margin-left:16px"
          >查看</el-button
        >
        <el-button
          class="filter-item"
          size="mini"
          icon="el-icon-refresh"
          style="margin-left:16px !important"
          @click="doReset"
          >重置</el-button
        >
      </div>
      <div class="big-summary">
        <div v-if="summary1 && Object.values(summary1).length > 0">
          <div class="summary-t1">
            总线索
            <el-tooltip
              class="item"
              effect="dark"
              content="1.同城下的单店排名（非集团总排名）；2.王朝、海洋所有商家一起排名；3.环比均为同期环比。"
              placement="right"
            >
              <i
                class="el-icon-question"
                style="color: #909399;font-size: 18px;margin-left: 5px;margin-top: 1px;"
              ></i>
            </el-tooltip>
          </div>
          <div class="summary-b">
            <div class="summary-b-l">
              <div class="summary-b-l-1">
                <span>总量</span>
                <div class="num">{{ summary1.thisCount }}</div>
              </div>
              <div class="summary-b-l-1" style="margin-top: 11px;">
                <span>环比</span>
                <div class="rate" :class="addClass(summary1.rate)">
                  <img :src="summary1.rate | imgFilter" alt="" />{{
                    Math.abs(summary1.rate)
                  }}%
                </div>
              </div>
            </div>
            <div class="summary-b-r">
              <div class="summary-b-l-1">
                <span>同城排名</span>
                <div class="num">{{ summary1.thisRank }}</div>
              </div>
              <div class="summary-b-l-1" style="margin-top: 11px;">
                <span style="width:40px">{{
                  (summary1.lastRank - summary1.thisRank) | namefitter
                }}</span>
                <div
                  class="rate"
                  :class="addClass(summary1.lastRank - summary1.thisRank)"
                >
                  <img
                    :src="(summary1.lastRank - summary1.thisRank) | imgFilter"
                    alt=""
                  />{{ Math.abs(summary1.lastRank - summary1.thisRank) }}
                </div>
              </div>
            </div>
          </div>
          <div class="no" v-show="summary1.thisRank === 1">
            <img src="../../assets/img/no1.png" alt="" />
          </div>
          <div class="no" v-show="summary1.thisRank === 2">
            <img src="../../assets/img/no2.png" alt="" />
          </div>
          <div class="no" v-show="summary1.thisRank === 3">
            <img src="../../assets/img/no3.png" alt="" />
          </div>
        </div>
        <div
          style="margin: 0 20px"
          v-if="summary2 && Object.values(summary2).length > 0"
        >
          <div class="summary-t1">线上</div>
          <div class="summary-b">
            <div class="summary-b-l">
              <div class="summary-b-l-1">
                <span>总量</span>
                <div class="num">{{ summary2.thisCount }}</div>
              </div>
              <div class="summary-b-l-1" style="margin-top: 11px;">
                <span>环比</span>
                <div class="rate" :class="addClass(summary2.rate)">
                  <img :src="summary2.rate | imgFilter" alt="" />{{
                    Math.abs(summary2.rate)
                  }}%
                </div>
              </div>
            </div>
            <div class="summary-b-r">
              <div class="summary-b-l-1">
                <span>同城排名</span>
                <div class="num">{{ summary2.thisRank }}</div>
              </div>
              <div class="summary-b-l-1" style="margin-top: 11px;">
                <span style="width:40px">{{
                  (summary2.lastRank - summary2.thisRank) | namefitter
                }}</span>
                <div
                  class="rate"
                  :class="addClass(summary2.lastRank - summary2.thisRank)"
                >
                  <img
                    :src="(summary2.lastRank - summary2.thisRank) | imgFilter"
                    alt=""
                  />{{ Math.abs(summary2.lastRank - summary2.thisRank) }}
                </div>
              </div>
            </div>
          </div>
          <div class="no" v-show="summary2.thisRank === 1">
            <img src="../../assets/img/no1.png" alt="" />
          </div>
          <div class="no" v-show="summary2.thisRank === 2">
            <img src="../../assets/img/no2.png" alt="" />
          </div>
          <div class="no" v-show="summary2.thisRank === 3">
            <img src="../../assets/img/no3.png" alt="" />
          </div>
        </div>
        <div v-if="summary3 && Object.values(summary3).length > 0">
          <div class="summary-t1">线下</div>
          <div class="summary-b">
            <div class="summary-b-l">
              <div class="summary-b-l-1">
                <span>总量</span>
                <div class="num">{{ summary3.thisCount }}</div>
              </div>
              <div class="summary-b-l-1" style="margin-top: 11px;">
                <span>环比</span>
                <div class="rate" :class="addClass(summary3.rate)">
                  <img :src="summary3.rate | imgFilter" alt="" />{{
                    Math.abs(summary3.rate)
                  }}%
                </div>
              </div>
            </div>
            <div class="summary-b-r">
              <div class="summary-b-l-1">
                <span>同城排名</span>
                <div class="num">{{ summary3.thisRank }}</div>
              </div>
              <div class="summary-b-l-1" style="margin-top: 11px;">
                <span style="width:40px">{{
                  (summary3.lastRank - summary3.thisRank) | namefitter
                }}</span>
                <div
                  class="rate"
                  :class="addClass(summary3.lastRank - summary3.thisRank)"
                >
                  <img
                    :src="(summary3.lastRank - summary3.thisRank) | imgFilter"
                    alt=""
                  />{{ Math.abs(summary3.lastRank - summary3.thisRank) }}
                </div>
              </div>
            </div>
          </div>
          <div class="no" v-show="summary3.thisRank === 1">
            <img src="../../assets/img/no1.png" alt="" />
          </div>
          <div class="no" v-show="summary3.thisRank === 2">
            <img src="../../assets/img/no2.png" alt="" />
          </div>
          <div class="no" v-show="summary3.thisRank === 3">
            <img src="../../assets/img/no3.png" alt="" />
          </div>
        </div>
      </div>
      <div class="tables">
        <div class="table1">
          <div class="table-title">线索构成与渠道健康度</div>
          <el-table
            :data="list1"
            v-loading="listLoading"
            row-key="id"
            max-height="480px"
            default-expand-all
            @row-click="(row, column, e) => clickRowLoad(row, column, e)"
            :header-cell-style="{ background: '#F4F5F6' }"
          >
            <el-table-column align="left" label="平台" width="150">
              <template slot-scope="scope">
                <span>{{ scope.row.name }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="thisCount" label="线索" min-width="130">
              <template slot-scope="scope">
                <span class="fs"
                  >{{ scope.row.thisCount }}
                  <span class="rate" :class="addClass(scope.row.rate)">
                    <img :src="scope.row.rate | imgFilter" alt="" />{{
                      Math.abs(scope.row.rate)
                    }}%
                  </span></span
                >
              </template>
            </el-table-column>
            <el-table-column label="同城排名" min-width="130" align="center">
              <template slot-scope="scope">
                <span class="fs">
                  <span
                    class="nos"
                    v-show="
                      scope.row.thisRank > 3 &&
                        rankName.indexOf(scope.row.name) >= 0
                    "
                    >{{ scope.row.thisRank }}</span
                  >
                  <img
                    src="../../assets/img/no11.png"
                    class="noimg"
                    v-show="
                      scope.row.thisRank === 1 &&
                        rankName.indexOf(scope.row.name) >= 0
                    "
                    alt=""
                  />
                  <img
                    src="../../assets/img/no22.png"
                    class="noimg"
                    v-show="
                      scope.row.thisRank === 2 &&
                        rankName.indexOf(scope.row.name) >= 0
                    "
                    alt=""
                  />
                  <img
                    src="../../assets/img/no33.png"
                    class="noimg"
                    v-show="
                      scope.row.thisRank === 3 &&
                        rankName.indexOf(scope.row.name) >= 0
                    "
                    alt=""
                  />
                  <span
                    class="none"
                    v-show="rankName.indexOf(scope.row.name) < 0"
                    >暂不开放</span
                  >
                </span>
              </template>
            </el-table-column>
            <el-table-column label="重复" min-width="130">
              <template slot-scope="scope">
                <span class="fs"
                  >{{ scope.row.thisRepeatCount }}
                  <span class="rate" :class="addClass(scope.row.repeatRate)">
                    <img :src="scope.row.repeatRate | imgFilter" alt="" />{{
                      Math.abs(scope.row.repeatRate)
                    }}%
                  </span></span
                >
              </template>
            </el-table-column>
            <el-table-column label="无效" min-width="130">
              <template slot-scope="scope">
                <span class="fs"
                  >{{ scope.row.thisInvalidCount }}
                  <span class="rate" :class="addClass(scope.row.invalidRate)">
                    <img :src="scope.row.invalidRate | imgFilter" alt="" />{{
                      Math.abs(scope.row.invalidRate)
                    }}%
                  </span></span
                >
              </template>
            </el-table-column>
            <el-table-column label="有效客户" min-width="130">
              <template slot-scope="scope">
                <span class="fs"
                  >{{ scope.row.thisValidCount }}
                  <span class="rate" :class="addClass(scope.row.validRate)">
                    <img :src="scope.row.validRate | imgFilter" alt="" />{{
                      Math.abs(scope.row.validRate)
                    }}%
                  </span></span
                >
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="table2">
          <div class="table-title">关键经营节点透视</div>
          <el-table
            :data="list2"
            v-loading="listLoading2"
            max-height="480px"
            :header-cell-style="{ background: '#F4F5F6' }"
          >
            <el-table-column align="left" label="" width="90" fixed="left">
              <template slot-scope="scope">
                <span>{{ scope.row.name }}</span>
              </template>
            </el-table-column>
            <el-table-column align="left" label="数量" min-width="100">
              <template slot-scope="scope">
                <span>{{ scope.row.thisCount }}</span>
              </template>
            </el-table-column>
            <el-table-column align="left" label="环比" min-width="100">
              <template slot-scope="scope">
                <span class="fs">
                  <span
                    class="rate"
                    style="margin-left: 0;"
                    :class="addClass(scope.row.rate)"
                  >
                    <img :src="scope.row.rate | imgFilter" alt="" />{{
                      Math.abs(scope.row.rate)
                    }}%
                  </span>
                </span>
              </template>
            </el-table-column>
            <el-table-column label="同城排名" align="center" min-width="100">
              <template slot-scope="scope">
                <span class="fs">
                  <span class="nos" v-show="scope.row.thisRank > 3">{{
                    scope.row.thisRank
                  }}</span>
                  <img
                    src="../../assets/img/no11.png"
                    v-show="scope.row.thisRank === 1"
                    alt=""
                    class="noimg"
                  />
                  <img
                    src="../../assets/img/no22.png"
                    v-show="scope.row.thisRank === 2"
                    alt=""
                    class="noimg"
                  />
                  <img
                    src="../../assets/img/no33.png"
                    v-show="scope.row.thisRank === 3"
                    class="noimg"
                    alt=""
                  />
                </span>
              </template>
            </el-table-column>
            <el-table-column align="left" label="试驾数" min-width="100">
              <template slot-scope="scope">
                <span>{{ scope.row.testDriveCount }}</span>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
      <div class="big-chart">
        <div class="chart-title">
          线索流转<el-tooltip
            class="item"
            effect="dark"
            content="所选时间范围内新增的线索对应的有效线索、到店客户、订车客户"
            placement="right"
          >
            <i
              class="el-icon-question"
              style="color: #909399;font-size: 18px;margin-left: 5px;"
            ></i>
          </el-tooltip>
        </div>
        <div class="chart-content" v-loading="chartLoading">
          <div id="bigChart"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Chart } from "@antv/g2";
// import no1 from "../../assets/img/no1.png";
// import no2 from "../../assets/img/no2.png";
// import no3 from "../../assets/img/no3.png";
import up from "../../assets/img/up.png";
import down from "../../assets/img/down.png";
import deng from "../../assets/img/deng.png";
import $ from "jquery";
export default {
  data() {
    return {
      dealer: this.$common.getDealer(),
      listLoading: false,
      listLoading2: false,
      listQuery: {
        dateType: 1,
        searchDate: new Date(),
        seriesId: "",
      },
      datePickerOption: {
        firstDayOfWeek: 1,
        disabledDate(time) {
          return time.getTime(new Date()) > Date.now();
        },
      },
      seriesOptions: [],
      startDate: "",
      summary1: {},
      summary2: {},
      summary3: {},
      list1: [],
      list2: [],
      rankName: ["线上", "线下", "汽车之家", "懂车帝", "易湃"],
      chartLoading: false,
      chart: null,
      chartData: [],
      up: up,
      down: down,
      deng: deng,
      dataStart: new Date(),
    };
  },
  methods: {
    //点击整行load
    clickRowLoad(r, c, e) {
      if (
        e.currentTarget.firstElementChild.firstElementChild.firstElementChild
          .tagName == "DIV"
      ) {
        e.currentTarget.firstElementChild.firstElementChild.firstElementChild.click();
      } else {
        e.currentTarget.firstElementChild.firstElementChild.firstElementChild.nextElementSibling.click();
      }
    },
    doSearch() {
      var startDate = "";
      if (this.listQuery.dateType == 1) {
        startDate = this.listQuery.searchDate.Format("yyyy-MM-dd");
      }
      if (this.listQuery.dateType == 3) {
        startDate = this.$common.getFirstDayOfWeek(this.listQuery.searchDate);
      }
      if (this.listQuery.dateType == 2) {
        startDate = this.$common.getFirstDayOfMonth(this.listQuery.searchDate);
      }
      this.startDate = startDate;
      this.getSummary(1);
      this.getSummary(2);
      this.getSummary(3);
      this.getlist1();
      this.getlist2();
      this.getChart();
    },
    getSummary(queryType) {
      this.$httpAuth
        .post("/v2/v2DealerReportRpc/bigScreenSummary", {
          dealerId: this.dealer.dealerId,
          dateType: this.listQuery.dateType,
          seriesId:
            this.listQuery.seriesId === "" ? 0 : this.listQuery.seriesId,
          startDate: this.startDate,
          queryType: queryType,
        })
        .then((res) => {
          switch (queryType) {
            case 1:
              this.summary1 = { ...res.data };
              break;
            case 2:
              this.summary2 = { ...res.data };
              break;
            case 3:
              this.summary3 = { ...res.data };
              break;

            default:
              break;
          }
        });
    },
    addClass(val) {
      if (val > 0) {
        return "up";
      } else if (val < 0) {
        return "down";
      } else {
        return "deng";
      }
    },
    doReset() {
      this.list = null;
      this.listLoading = false;
      this.listQuery = {
        dateType: 1,
        searchDate: new Date(),
        seriesId: "",
      };
      this.doSearch();
    },
    retrieveSeriesOptions() {
      var parent = this;
      this.$httpAuth
        .post("/v1/dealerRpc/seriesList", {
          dealerId: this.dealer.dealerId,
        })
        .then(function(response) {
          parent.seriesOptions = response.data.records;
        });
    },
    getlist1() {
      this.listLoading = true;
      this.$httpAuth
        .post("/v2/v2DealerReportRpc/bigScreenClueSource", {
          dealerId: this.dealer.dealerId,
          dateType: this.listQuery.dateType,
          seriesId:
            this.listQuery.seriesId === "" ? 0 : this.listQuery.seriesId,
          startDate: this.startDate,
        })
        .then((res) => {
          var list = [];
          res.data.data.forEach((item, index) => {
            item["id"] = index + 1;
          });
          list[0] = res.data.data.filter((item) => item.name === "线上")[0];
          list[1] = res.data.data.filter((item) => item.name === "线下")[0];
          list[0]["children"] = [];
          list[1]["children"] = [];
          var index = res.data.data.map((item) => item.name).indexOf("线下");
          list[0].children = [...res.data.data.slice(1, index)];
          list[1].children = [...res.data.data.slice(index + 1)];
          this.list1 = [...list];
          this.listLoading = false;
        })
        .catch(() => {
          this.listLoading = false;
        });
    },
    getlist2() {
      this.listLoading2 = true;
      this.$httpAuth
        .post("/v2/v2DealerReportRpc/bigScreenClueState", {
          dealerId: this.dealer.dealerId,
          dateType: this.listQuery.dateType,
          seriesId:
            this.listQuery.seriesId === "" ? 0 : this.listQuery.seriesId,
          startDate: this.startDate,
        })
        .then((res) => {
          this.listLoading2 = false;
          this.list2 = [...res.data.data];
        })
        .catch(() => {
          this.listLoading2 = false;
        });
    },
    getChart() {
      this.$httpAuth
        .post("/v2/v2DealerReportRpc/bigScreenClueChart", {
          dealerId: this.dealer.dealerId,
          dateType: this.listQuery.dateType,
          seriesId:
            this.listQuery.seriesId === "" ? 0 : this.listQuery.seriesId,
          startDate: this.startDate,
        })
        .then((res) => {
          this.chartLoading = false;
          var count = res.data.data.filter((item) => item.name === "线索")[0]
            .count;
          res.data.data.forEach((item) => {
            item["percent"] = item.count / count;
          });
          this.renderChart([...res.data.data]);
        })
        .catch(() => {
          this.chartLoading = false;
        });
    },
    renderChart(chartData) {
      if (this.chart != null) {
        this.chart.clear();
      } else {
        this.chart = new Chart({
          container: "bigChart",
          forceFit: true,
          height: 450,
          padding: [20, 350, 50, 250],
        });
      }
      this.chart.source(chartData, {
        percent: {
          nice: false,
        },
      });
      this.chart.axis(false);
      this.chart.tooltip(false);
      this.chart.legend(false);
      this.chart
        .coord("rect")
        .transpose()
        .scale(1, -1);
      var that = this;
      that.chart
        .intervalSymmetric()
        .position("name*percent")
        .label("name", {
          offset: 200,
          labelLine: {
            lineWidth: 1,
            stroke: "rgba(0, 0, 0, 0.15)",
          },
          htmlTemplate: (text, item) => {
            const point = item.point;
            switch (point.name) {
              case "线索":
                return "";
              case "有效":
                return (
                  "<div class='chart-box1'>" +
                  "<div>线索有效率" +
                  "<span>" +
                  point.rate1 +
                  "%" +
                  "</span>" +
                  "</div>" +
                  "<div>" +
                  "环比" +
                  "<span class=" +
                  that.addClass(point.compareRate1) +
                  ">" +
                  Math.abs(point.compareRate1) +
                  "%" +
                  "</span>" +
                  "<img src=" +
                  that.addSrc(point.compareRate1) +
                  " />" +
                  "</div>" +
                  "</div>"
                );

              case "首到店":
                return (
                  "<div class='chart-box1 chart-box2'>" +
                  "<div>线索到店率" +
                  "<span>" +
                  point.rate1 +
                  "%" +
                  "</span>" +
                  "</div>" +
                  "<div>" +
                  "环比" +
                  "<span class=" +
                  that.addClass(point.compareRate1) +
                  ">" +
                  Math.abs(point.compareRate1) +
                  "%" +
                  "</span>" +
                  "<img src=" +
                  that.addSrc(point.compareRate1) +
                  " />" +
                  "</div>" +
                  "<div>有效到店率" +
                  "<span>" +
                  point.rate2 +
                  "% " +
                  "</span>" +
                  "</div>" +
                  "<div>" +
                  "环比" +
                  "<span class=" +
                  that.addClass(point.compareRate2) +
                  ">" +
                  Math.abs(point.compareRate2) +
                  "%" +
                  "</span>" +
                  "<img src=" +
                  that.addSrc(point.compareRate2) +
                  " />" +
                  "</div>" +
                  "</div>"
                );

              case "订车":
                return (
                  "<div class='chart-box1 chart-box2'>" +
                  "<div>线索订车率" +
                  "<span>" +
                  point.rate1 +
                  "%" +
                  "</span>" +
                  "</div>" +
                  "<div>" +
                  "环比" +
                  "<span class=" +
                  that.addClass(point.compareRate1) +
                  ">" +
                  Math.abs(point.compareRate1) +
                  "%" +
                  "</span>" +
                  "<img src=" +
                  that.addSrc(point.compareRate1) +
                  " />" +
                  "</div>" +
                  "<div>到店订车率" +
                  "<span>" +
                  point.rate2 +
                  "% " +
                  "</span>" +
                  "</div>" +
                  "<div>" +
                  "环比" +
                  "<span class=" +
                  that.addClass(point.compareRate2) +
                  ">" +
                  Math.abs(point.compareRate2) +
                  "%" +
                  "</span>" +
                  "<img src=" +
                  that.addSrc(point.compareRate2) +
                  " />" +
                  "</div>" +
                  "</div>"
                );


              default:
                break;
            }
          },
        })
        .shape("funnel")
        .color("name", ["#FF3D10", "#FF8B70", "#FFB19F", "#FFD8CF"])
        .style({
          lineWidth: 3,
          stroke: "#fff",
        });

      chartData.forEach(function(obj) {
        that.chart.guide().line({
          start: {
            name: obj.name,
            percent: -0.18,
          }, // 使用对象格式
          end: {
            name: obj.name,
            percent:
              obj.percent === 1
                ? 0
                : 0.5 - obj.percent < 0
                ? obj.percent - 0.5
                : 0.5 - obj.percent,
          },
          lineStyle: {
            stroke: "rgba(0, 0, 0, 0.15)", // 线的颜色
            lineWidth: 1, // 线的宽度
            lineDash: 0,
          }, // 图形样式配置
          text: {
            position: "start",
            autoRotate: false,
            content: obj.name + " " + obj.count,
            style: {
              textAlign: "center",
              fill: "#000", // 文本颜色
            },
            offsetX: -50, // x 方向的偏移量
            offsetY: 8, // y 方向的偏移量
          },
        });
      });
      setTimeout(() => {
        that.chart.render();
      }, 500);
    },
    addSrc(val) {
      if (val > 0) {
        return this.up;
      } else if (val < 0) {
        return this.down;
      } else {
        return this.deng;
      }
    },
    dateStart() {
      // $("#currentWeekly input").val(
      //   this.$moment().isoWeekYear() +
      //     "年" +
      //     (Number(this.$moment(this.listQuery.searchDate).isoWeek()) + 1) +
      //     "周"
      // );
    },
    dateTypeChange(val) {
      this.listQuery.searchDate = new Date();
      // if (val === 3) {
        // $("#currentWeekly input").val(
        //   this.$moment().isoWeekYear() +
        //     "年" +
        //     (Number(this.$moment(this.listQuery.searchDate).isoWeek()) + 1) +
        //     "周"
        // );
      // }
    },
  },
  created() {
    this.retrieveSeriesOptions();
  },
  mounted() {
    this.$nextTick(() => {
      this.doSearch();
    });
  },
  watch: {
    "listQuery.searchDate"(newVal) {
      if (this.listQuery.dateType == 3) {
        this.$nextTick(() => {
          //获取当前非ISOWEEK周数
          // $("#currentWeekly input").val(
          //   this.$moment().isoWeekYear() +
          //     "年" +
          //     (Number(this.$moment(newVal).isoWeek()) + 1) +
          //     "周"
          // );
        });
      }
    },
  },
  filters: {
    imgFilter(val) {
      if (val > 0) {
        return up;
      } else if (val < 0) {
        return down;
      } else {
        return deng;
      }
    },
    namefitter(val) {
      if (val > 0) {
        return "上升";
      } else if (val < 0) {
        return "下降";
      } else {
        return "持平";
      }
    },
  },
};
</script>

<style>
.big-top {
  width: 100%;
  height: 70px;
  background: #ffffff;
  border-radius: 5px;
  display: flex;
  align-items: center;
  padding-left: 23px;
  box-sizing: border-box;
  margin-right: 20px;
}
.big-summary {
  width: 100%;
  height: 153px;
  display: flex;
  margin-top: 20px;
  margin-right: 20px;
}
.big-summary > div {
  flex: 1;
  height: 100%;
  background: #ffffff;
  border-radius: 5px;
  position: relative;
}
.no {
  width: 86px;
  height: 99px;
  position: absolute;
  right: 28px;
  top: 31px;
}
.no img {
  width: 100%;
}
.summary-t1 {
  height: 31px;
  font-size: 14px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: rgba(0, 0, 0, 0.85);
  padding-top: 14px;
  padding-left: 27px;
  box-sizing: border-box;
  display: flex;
}
.summary-b {
  width: 100%;
  display: flex;
  height: 119px;
}
.summary-b-l {
  width: 40%;
  max-width: 200px;
  padding-left: 27px;
  padding-top: 18px;
  box-sizing: border-box;
  position: relative;
}
.summary-b-l::after {
  position: absolute;
  content: "";
  width: 1px;
  height: 60px;
  background-color: rgba(151, 151, 151, 0.46);
  right: 0;
  top: 50%;
  transform: translateY(-50%);
}
.summary-b-l-1 {
  height: 28px;
  display: flex;
  align-items: center;
}
.summary-b-l-1 span {
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #9d9d9d;
  width: 54px;
}
.summary-b-l-1 .num {
  font-size: 24px;
  font-family: DINAlternate-Bold, DINAlternate;
  font-weight: bold;
  color: rgba(0, 0, 0, 0.85);
}
.summary-b-l-1 .rate {
  font-size: 24px;
  font-family: DINAlternate-Bold, DINAlternate;
  font-weight: bold;
  display: flex;
  align-items: center;
  height: 28px;
}
.summary-b-l-1 .rate.up {
  color: #fd3e3e;
}
.summary-b-l-1 .rate.down {
  color: #20cd58;
}
.summary-b-l-1 .rate.deng {
  color: rgb(93, 162, 248);
}
.summary-b-l-1 img {
  width: 11px;
  margin-right: 4px;
}
.summary-b-r {
  padding-left: 40px;
  padding-top: 18px;
  box-sizing: border-box;
}
.summary-b-r .summary-b-l-1 span {
  width: 56px;
}
.tables {
  width: 100%;
  display: flex;
  justify-content: space-between;
  height: 550px;
  margin-top: 20px;
  margin-right: 20px;
}
.tables .table1 {
  width: 60%;
  height: 550px;
  background: #ffffff;
  border-radius: 5px;
  padding: 0 25px;
  box-sizing: border-box;
}
.tables .table2 {
  width: calc(40% - 20px);
  height: 550px;
  background: #ffffff;
  border-radius: 5px;
  margin-left: 20px;
  padding: 0 25px;
  box-sizing: border-box;
}
.tables .el-table {
  width: 100%;
  border: none;
}
.table-title {
  height: 63px;
  line-height: 63px;
  font-size: 14px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: rgba(0, 0, 0, 0.85);
}
.el-table .rate {
  display: flex;
  height: 23px;
  border-radius: 4px;
  font-family: DINAlternate-Bold, DINAlternate;
  font-weight: bold;
  align-items: center;
  justify-content: center;
  margin-left: 20px;
  font-size: 12px;
  padding: 0 15px;
}
.el-table .rate img {
  width: 7px;
  margin-right: 2px;
}
.el-table .rate.up {
  background-color: rgba(255, 243, 243, 1);
  color: rgba(253, 87, 87, 1);
}
.el-table .rate.down {
  background-color: rgba(221, 249, 230, 1);
  color: rgba(32, 205, 88, 1);
}
.el-table .rate.deng {
  background-color: rgb(93, 162, 248, 0.2);
  color: rgb(93, 162, 248);
}
.fs {
  display: flex;
}
.fs .nos {
  font-size: 16px;
  font-family: DINAlternate-Bold, DINAlternate;
  font-weight: bold;
  color: #ff8b6f;
  margin: 0 auto;
}
.fs img {
  width: 15px;
}
.fs .none {
  width: 57px;
  height: 22px;
  display: block;
  background: rgba(216, 216, 216, 0.36);
  border-radius: 5px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #acacac;
  text-align: center;
  font-size: 12px;
  margin: 0 auto;
}
.fs .noimg {
  width: 22px;
  margin: 0 auto;
}
.big-chart {
  width: 100%;
  height: 528px;
  background: #ffffff;
  border-radius: 5px;
  margin-top: 20px;
  padding-top: 25px;
  box-sizing: border-box;
  margin-right: 20px;
}
.big-chart .chart-title {
  font-size: 14px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: rgba(0, 0, 0, 0.85);
  padding-left: 27px;
  box-sizing: border-box;
}
.big-chart .chart-content {
  width: 100%;
  height: 480px;
  display: flex;
  justify-content: center;
}
.big-chart .chart-content #bigChart {
  height: 400px;
  width: 90%;
}
.chart-box1 {
  display: flex;
  width: 210px;
  height: 39px;
  background: #ffffff;
  box-shadow: 0px 0px 9px 0px rgba(255, 127, 96, 0.39);
  border-radius: 5px;
  background: rgba(255, 255, 255, 0.66);
  border: 1px solid #ff3d0f;
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(0, 0, 0, 0.85);
  padding-left: 10px;
  box-sizing: border-box;
}
.chart-box1 > div {
  width: 95px;
  display: flex;
  align-items: center;
}
.chart-box2 {
  height: 65px;
  flex-wrap: wrap;
}
.chart-box1 > div > span {
  color: #ff3d0f;
}
.chart-box1 > div > span.up {
  color: #fd3e3e;
}
.chart-box1 > div > span.down {
  color: #20cd58;
}
.chart-box1 > div > span.deng {
  color: rgb(93, 162, 248);
}
.chart-box1 > div img {
  width: 6px;
}
.htmlSpan1 {
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(0, 0, 0, 0.85);
}
</style>
